import { router } from '@lifedot/router'
import { FC } from 'react'
import { css } from '@emotion/react'
import Link from 'next/link'
import { typography } from '@lifedot/styles/typography'

const styles = {
  name: css({
    fontWeight: 'bold'
  })
}

interface CemeteryNameWithLinkProps {
  cemeteryId: number
  name: string
}

export const CemeteryNameWithLink: FC<CemeteryNameWithLinkProps> = ({
  name,
  cemeteryId
}) => {
  return (
    <Link href={router.cemetery(cemeteryId)} prefetch={false} passHref>
      <a css={[typography.textM, styles.name]}>{name}</a>
    </Link>
  )
}
